export const PS_FOOTER_LOADER = {
  desktop: `
  <div class="cui-grid">
  <div class="cui-container -spacing--top-64 -spacing--bottom-32">
    <div class="cui-row">
      <div class="cui-col-md-2 col-offset-md-3">
        <div class="cui-skeleton-paragraph -size--large -resolution--desktop -spacing--bottom-24">
          <div class="cui-skeleton-paragraph__content" style="width: 100%;">
            <div class="cui-skeleton__item cui-skeleton__description"></div>
          </div>
        </div>
        <div class="cui-skeleton-paragraph -size--large -resolution--desktop">
          <div class="cui-skeleton-paragraph__content" style="width: 100%;">
            <div class="cui-skeleton__item cui-skeleton__description"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>`
};
